import { useEffect, useRef } from "react";
import { useSearchParams } from "react-router-dom";
import { Loader2 } from "lucide-react";
import { PLANOS, irParaPagamento } from "@/lib/planos";

// /checkout?plano=anual abre direto o pagamento do plano (serve para link de
// anuncio). Sem plano, ou com plano invalido, mostra a lista de planos.
// O link antigo de R$ 29,90 do Stripe nao e mais usado.
export default function CheckoutRedirect() {
  const [params] = useSearchParams();
  const iniciado = useRef(false);

  useEffect(() => {
    if (iniciado.current) return;
    iniciado.current = true;
    const plano = params.get("plano");
    if (PLANOS.some((p) => p.id === plano)) {
      irParaPagamento(plano).catch(() => window.location.replace("/#planos"));
    } else {
      window.location.replace("/#planos");
    }
  }, [params]);

  return (
    <div className="min-h-screen bg-slate-50 dark:bg-slate-950 flex items-center justify-center p-4">
      <div className="text-center space-y-4" data-testid="checkout-loading">
        <Loader2 className="w-12 h-12 text-teal-600 animate-spin mx-auto" />
        <p className="text-slate-700 dark:text-slate-300 text-lg font-medium">Abrindo o pagamento...</p>
      </div>
    </div>
  );
}
